import { css } from 'lit';
export const chatbotEscalationPillStyles = css``;
